module.exports = __webpack_public_path__ + "img/Newbie_Dagger_01_Mage.edce0af6.png";